/**
 * User Metadata Service
 * Handles fetching user preferences and system settings from the backend
 */

/**
 * Get the user's last active organization ID
 */
export async function getLastActiveOrganizationId(): Promise<string | null> {
  try {
    const response = await fetch('/api/user/metadata/organization/lastActiveOrgId', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      console.error('Failed to fetch last active organization:', response.status);
      return null;
    }

    const data = await response.json();
    return data.value || null;
  } catch (error) {
    console.error('Error fetching last active organization ID:', error);
    return null;
  }
}

/**
 * Get all organization-related metadata options
 */
export async function getOrganizationMetadata(): Promise<Array<{ key: string; type: string; value: any }>> {
  try {
    const response = await fetch('/api/user/metadata/organization', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      console.error('Failed to fetch organization metadata:', response.status);
      return [];
    }

    const data = await response.json();
    return data.data || [];
  } catch (error) {
    console.error('Error fetching organization metadata:', error);
    return [];
  }
}
